import { h, Host } from "@stencil/core";
import { ButtonSize, ButtonVariant } from "../../button/button.enum";
export class ChatMessageBar {
    constructor() {
        this.placeholder = undefined;
        this.disabled = undefined;
        this.messageText = "";
    }
    /** Fired when the message has been sent */
    usMessageSend;
    handleInput(event) {
        this.messageText = event.target.value;
    }
    handleKeydown(event) {
        if (event.ctrlKey && event.key === "Enter") {
            this.sendMessage();
        }
    }
    sendMessage() {
        if (!this.disabled && this.messageText.trim()) {
            this.usMessageSend.emit(this.messageText);
            this.messageText = "";
        }
    }
    render() {
        return (h(Host, { key: '6eed26a00877ae99ea2e60e85c044a3b89264c76' }, h("div", { key: '7b5877ea76e721dd4f3efbd1b7b8f0dc542c20c8', id: "chat-message-bar" }, h("ux-input", { key: '3ee7478196398d205a6348d2484a128533e0bf82', id: "chat-textarea", name: "chat-message", placeholder: this.placeholder, disabled: this.disabled ? false : undefined, value: this.messageText, onInput: (event) => this.handleInput(event), onKeyDown: (event) => this.handleKeydown(event) }), h("ux-button", { key: '1d6795fdb503a30764635924d157bbf452998a06', size: ButtonSize.Icon, variant: ButtonVariant.Primary, icon: "paper-plane", label: "Send", disabled: this.disabled, onClick: () => this.sendMessage() }))));
    }
    static get is() { return "ux-chat-message-bar"; }
    static get encapsulation() { return "shadow"; }
    static get originalStyleUrls() {
        return {
            "$": ["chat-message-bar.scss"]
        };
    }
    static get styleUrls() {
        return {
            "$": ["chat-message-bar.css"]
        };
    }
    static get properties() {
        return {
            "placeholder": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": true,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "The placeholder text."
                },
                "attribute": "placeholder",
                "reflect": false
            },
            "disabled": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean | undefined",
                    "references": {}
                },
                "required": false,
                "optional": true,
                "docs": {
                    "tags": [],
                    "text": "indicates if the message bar is disabled"
                },
                "attribute": "disabled",
                "reflect": false
            }
        };
    }
    static get states() {
        return {
            "messageText": {}
        };
    }
    static get events() {
        return [{
                "method": "usMessageSend",
                "name": "usMessageSend",
                "bubbles": true,
                "cancelable": true,
                "composed": true,
                "docs": {
                    "tags": [],
                    "text": "Fired when the message has been sent"
                },
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                }
            }];
    }
}
//# sourceMappingURL=chat-message-bar.js.map
